import { Component, OnInit } from '@angular/core';

import { TransactionsService } from '../../services/transactions.service';

@Component({
  selector: 'ap-average-performance',
  templateUrl: './average-performance.component.html',
  styleUrls: ['./average-performance.component.scss']
})
export class AveragePerformanceComponent implements OnInit {

  public weeks: any;
  public chartColumns = ['Year', 'Weekly Average'];
  public chartOptions = {
    title: '5 Week Performance Average',
    vAxis: {title: 'Weekly Average $'},
    hAxis: {title: 'Weeks'},
    legend: 'none',
    trendlines: { 0: {} }
  };

  public totalExpenses = 0;
  public totalRevenue = 0;

  public weeksRevenue: any = [];

  constructor(private transactionService: TransactionsService) { }

  ngOnInit(): void {

    // GET TOTAL AMOUNT SPENT FROM EXPENSES
    this.totalAmountSpentExpense();
    this.totalAmountRevenue();

    this.transactionService.find({'source.account': '480004229'}, 0, 0).subscribe((transactions) => {

      let summedValues: number[] = [];
      let tempx: any[] = [];
      // Group transactions by week
      for (let transaction of transactions) {

        if (transaction.amount > 0) {
          let temp: string[] = getWeekNumber(new Date(transaction.date));
          let weekNumber: string = temp[0].toString() + "-" + temp[1].toString();

          if (summedValues[weekNumber] == undefined) {
            summedValues[weekNumber] = 0;
            tempx[weekNumber] = {amount: 0}
            tempx[weekNumber].transactions = [];
          }

          summedValues[weekNumber] += transaction.amount;
          tempx[weekNumber].amount += transaction.amount;
          tempx[weekNumber].transactions.push(transaction);
        }
      }




      let weeks: Week[] = new Array();

      // Get all the dates and sort
      let dates: number[] = [];
      for (let transaction of transactions) {

        let date = new Date(transaction.date);
        if (date.getTime() != 0) {
          dates.push(date.getTime());
        }
      }

      dates.sort((a, b) => a - b);

      // Get the oldest
      let oldestDate = dates[0];
      let newestDate = dates[dates.length - 1];
      let CountWeeks = Math.ceil((newestDate - oldestDate) / 1000 / 60 / 60 / 24 / 7);

      let counter = getWeekNumber(new Date(oldestDate))[1];
      let year = getWeekNumber(new Date(oldestDate))[0];
      for (let i = 0; i < CountWeeks; i++) {

        let weekNum = (counter % 53);

        if (weekNum == 0) { 
          counter++;
          weekNum++;
          year++;
        }

        let weekAmount = 0;
        if (summedValues[year+"-"+weekNum] !== undefined) {
          weekAmount = summedValues[year+"-"+weekNum];
        }

        weeks.push({
          weekYear: year,
          weekNumber: weekNum,
          weekAmount: Number.parseFloat(weekAmount.toFixed(2)),
          weekAverage: 0,
          weekDate: getDateOfISOWeek(weekNum, year)
        });

        counter++;
      }

      this.weeksRevenue = weeks;
    })


    this.transactionService.find({'source.account': '425866854'}, 0, 0).subscribe((transactions) => {

      let summedValues: number[] = [];
      let tempx: any[] = [];
      // Group transactions by week
      for (let transaction of transactions) {

        if (transaction.amount > 0) {
          let temp: string[] = getWeekNumber(new Date(transaction.date));
          let weekNumber: string = temp[0].toString() + "-" + temp[1].toString();
          
          if (summedValues[weekNumber] == undefined) {
            summedValues[weekNumber] = 0;
            tempx[weekNumber] = {amount: 0}
            tempx[weekNumber].transactions = [];
          }

          summedValues[weekNumber] += transaction.amount;
          tempx[weekNumber].amount += transaction.amount;
          tempx[weekNumber].transactions.push(transaction);
        }
      }


      let weeks: Week[] = new Array();

      // Get all the dates and sort
      let dates: number[] = [];
      for (let transaction of transactions) {

        let date = new Date(transaction.date);
        dates.push(date.getTime());
      }

      dates.sort((a, b) => a - b);

      // Get the oldest
      let oldestDate = dates[0];
      let newestDate = dates[dates.length - 1];
      let CountWeeks = Math.ceil((newestDate - oldestDate) / 1000 / 60 / 60 / 24 / 7);

      let counter = getWeekNumber(new Date(oldestDate))[1];
      let year = getWeekNumber(new Date(oldestDate))[0];
      for (let i = 0; i < CountWeeks; i++) {

        let weekNum = (counter % 53);

        if (weekNum == 0) { 
          counter++;
          weekNum++;
          year++;
        }

        let weekAmount = 0;
        if (summedValues[year+"-"+weekNum] !== undefined) {
          weekAmount = summedValues[year+"-"+weekNum];
        }

        weeks.push({
          weekYear: year,
          weekNumber: weekNum,
          weekAmount: Number.parseFloat(weekAmount.toFixed(2)),
          weekAverage: 0,
          weekDate: getDateOfISOWeek(weekNum, year)
        });

        counter++;
      }

      // Average transactions across last 5 weeks
      let averageOverWeeks = 7;
      averageOverWeeks--;
      for (let i = weeks.length-1; i >= 0; i--) { // Iterate over all weeks backwards
        let currentAverage = 0;

        let x = 0;
        if (i >= averageOverWeeks) {
          x = i-averageOverWeeks;
        }

        for (; x <= i; x++) { // Iterate up to current week forwards
          currentAverage += weeks[x].weekAmount;
        }

        weeks[i].weekAverage = Math.round(currentAverage / (averageOverWeeks+1));
      }

      let temp: any[] = [];
      for (let week of weeks) {
        temp.push([
          week.weekDate,
          week.weekAverage/100
        ])
      }

      this.weeks = temp;
    })
  }


  totalAmountSpentExpense() {
    this.transactionService.find({account: '442829529'}, 0, 0).subscribe((transactions) => {
      for(let transaction of transactions) {
        if (transaction.amount < 0) {
          this.totalExpenses += transaction.amount;
        }
      }
    })
  }

  totalAmountRevenue() {
    this.transactionService.find({account: '480004229'}, 0, 0).subscribe((transactions) => {
      for(let transaction of transactions) {
        if (transaction.amount > 0) {
          this.totalRevenue += transaction.amount;
        }
      }
    })
  }

}



interface Week {
  weekYear: number;
  weekNumber: number;
  weekAmount: number;
  weekAverage: number;
  weekDate: Date;
}



function getWeekNumber(dt){
  var calc=function(o){
    if(o.dtmin.getDay()!=1){
      if(o.dtmin.getDay()<=4 && o.dtmin.getDay()!=0)o.w+=1;
      o.dtmin.setDate((o.dtmin.getDay()==0)? 2 : 1+(7-o.dtmin.getDay())+1);
    }
    o.w+=Math.ceil((((o.dtmax.getTime()-o.dtmin.getTime())/(24*60*60*1000))+1)/7);
  },getNbDaysInAMonth=function(year,month){
    var nbdays=31;
    for(var i=0;i<=3;i++){
      nbdays=nbdays-i;
      let dtInst;
      if((dtInst=new Date(year,month-1,nbdays)) && dtInst.getDate()==nbdays && (dtInst.getMonth()+1)==month  && dtInst.getFullYear()==year)
        break;
    }
    return nbdays;
  };
  if(dt.getMonth()+1==1 && dt.getDate()>=1 && dt.getDate()<=3 && (dt.getDay()>=5 || dt.getDay()==0)){
    var pyData={"dtmin":new Date(dt.getFullYear()-1,0,1,0,0,0,0),"dtmax":new Date(dt.getFullYear()-1,11,getNbDaysInAMonth(dt.getFullYear()-1,12),0,0,0,0),"w":0};
    calc(pyData);
    return [dt.getUTCFullYear(),pyData.w];
  }else{
    var ayData={"dtmin":new Date(dt.getFullYear(),0,1,0,0,0,0),"dtmax":new Date(dt.getFullYear(),dt.getMonth(),dt.getDate(),0,0,0,0),"w":0},
      nd12m=getNbDaysInAMonth(dt.getFullYear(),12);
    if(dt.getMonth()==12 && dt.getDay()!=0 && dt.getDay()<=3 && nd12m-dt.getDate()<=3-dt.getDay())ayData.w=1;else calc(ayData);
    return [dt.getUTCFullYear(), ayData.w, dt];
  }
}

function getDateOfISOWeek(w, y) {
  var simple = new Date(y, 0, 1 + (w - 1) * 7);
  var dow = simple.getDay();
  var ISOweekStart = simple;
  if (dow <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  return ISOweekStart;
}